export default __webpack_public_path__ + "img/07056f63e8c473236477048e259e3273.svg";